import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=93c6358a&"
import script from "./Pagination.vue?vue&type=script&lang=js&"
export * from "./Pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93c6358a')) {
      api.createRecord('93c6358a', component.options)
    } else {
      api.reload('93c6358a', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=93c6358a&", function () {
      api.rerender('93c6358a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/base-table/Pagination.vue"
export default component.exports